<template>
  <div class="skill-inf-list ccs-fields">
    <modal :title="modalTitle"
      @close="switchModal"
      v-if="modal">
      <zone v-if="isZoneModal" @close="switchModal" :data="editableData"/>
      <equipment v-else :zone_id="currentZoneID" @close="switchModal" :data="editableData"/>
    </modal>
    <div class="indicators ccs-layout" v-if="!editMode">
      <div class="indicator">
        <div class="indicator-val">
          5
        </div>
        <div class="indicator-text">
          Количество экспертов<br/>(в том числе с ГЭ и ЗГЭ)
        </div>
      </div>
      <div class="indicator">
        <div class="indicator-val">
          10
        </div>
        <div class="indicator-text">
          Количество конкурсантов
        </div>
      </div>
      <div class="indicator">
        <div class="indicator-val">
          5
        </div>
        <div class="indicator-text">
          Количество рабочих мест
        </div>
      </div>
    </div>
    <div class="edit-header" v-if="editMode">
      <div class="title">
        Инфраструктурный лист. Редактирование
      </div>
    </div>
    <div class="area-info">
      <div class="area-info__content">
        <div class="area-info__row">
          <div class="area-info__title">
            Статус инфраструктурного листа
          </div>
          <div class="area-info__text">
            {{ skill.equipment_status.name }}
          </div>
        </div>
        <div class="area-info__row" v-if="!editMode">
          <div class="area-info__title">
            Общая площадь застройки компетенции
          </div>
          <div class="area-info__text">
            В помещении 11*7 метров (77 м.кв.). На улице не менее 50*50 метров (2500 м.кв.)
          </div>
        </div>
      </div>
    </div>
    <details v-for="zone in zones" :key="zone.id">
      <summary>
        {{ zone.name }}
        <img src="@/assets/icons/details_arrow.svg" alt=""
          class="summary-icon">
      </summary>
      <ccs-table :data="zone.equipments" :columnsDefs="columnsDefs">
        <template v-slot:status="props">
          {{ props.isEmpty ? 'Неизвестно' : parseEquipmentStatus(props.row.status) }}
        </template>
        <template v-slot:sponsor="props">
          {{ props.isEmpty ? 'Отсутствует' : props.row.sponsor.name }}
        </template>
        <template v-slot:actions="props">
          <v-icon v-if="isEquipmentUpdateAllowed"
            class="ccs-icon--primary ccs-icon--hover"
            name="edit"
            @click="startEquipmentEditing(props.row)"/>
          <v-icon v-if="isEquipmentDeleteAllowed"
            class="ccs-icon--secondary ccs-icon--hover"
            name="trash" scale="0.9"
            @click="removeEquipment(props.row, zone.id)"/>
        </template>
      </ccs-table>
      <div class="ccs-table__actions" v-if="editMode">
        <button v-if="(rolesStatus.isAdmin || !isEquipmentsBlocked) && permissionsStatus.isZoneUpdateAllowed"
          class="ccs-button ccs-button--white
          ccs-button--transparent ccs-button--no-border" @click="startEquipmentAdding(zone.id)">
          <img src="@/assets/icons/add.svg" alt="" class="button-icon">
          Добавить позицию
        </button>
        <button v-if="(rolesStatus.isAdmin || !isEquipmentsBlocked) && permissionsStatus.isZoneUpdateAllowed"
          class="ccs-button ccs-button--white ccs-button--slim
          ccs-button--transparent ccs-button--no-border" @click="startZoneEditing(zone)">
          <img src="@/assets/icons/edit.svg" alt="" class="button-icon">
          Редактировать зону
        </button>
        <button v-if="(rolesStatus.isAdmin || !isEquipmentsBlocked) && permissionsStatus.isZoneDeleteAllowed"
          class="ccs-button ccs-button--white ccs-button--slim
          ccs-button--transparent ccs-button--no-border" @click="removeZone(zone.id)">
          <img src="@/assets/icons/delete.svg" alt="" class="button-icon">
          Удалить зону
        </button>
      </div>
    </details>
    <div class="actions ccs-layout ccs-layput--no-pad">
      <div v-if="!editMode">
        <button class="ccs-button" @click="switchEditMode">Редактировать</button>
      </div>
      <div v-if="editMode">
        <button class="ccs-button" @click="switchEditMode">Выйти из редактирования</button>
      </div>
      <div v-if="editMode">
        <button v-if="permissionsStatus.isZoneCreateAllowed"
          class="ccs-button ccs-button--white" @click="startZoneAdding">
          <img src="@/assets/icons/add.svg" alt="" class="button-icon">
          Добавить раздел
        </button>
      </div>
      <div v-if="editMode && permissionsStatus.isZoneBlockAllowed && isEquipmentsBlocked">
        <button :disabled="!isEquipmentsUnblockAllowed"
          class="ccs-button ccs-button--white" @click="unlockEquipments">
          <img src="@/assets/icons/eye.svg" alt="" class="button-icon">
          Разблокировать ИЛ
        </button>
      </div>
      <div v-if="editMode && permissionsStatus.isZoneBlockAllowed && (rolesStatus.isAdmin || !isEquipmentsBlocked)">
        <button
          :disabled="!isEquipmentsBlockAllowed"
          class="ccs-button ccs-button--white" @click="lockEquipments">
          <img src="@/assets/icons/close.svg" alt="" class="button-icon">
          Заблокировать ИЛ
        </button>
      </div>
      <div v-if="editMode && permissionsStatus.isZonePublishAllowed && (rolesStatus.isAdmin || isEquipmentsBlocked)">
        <button v-if="!skill.public_code"
          class="ccs-button ccs-button--white" @click="publish()">
          Опубликовать
        </button>
        <button v-else
          class="ccs-button ccs-button--white" @click="copyPublicLink()">
          Скопировать публичную ссылку
        </button>
      </div>
      <div v-if="!editMode">
        <button class="ccs-button ccs-button--blight ccs-button--no-border ccs-button--small">
          <img src="@/assets/icons/file_xlsx.svg" alt="" class="button-icon">
          Скачать Excel
        </button>
      </div>
      <div v-if="!editMode">
         <button class="ccs-button ccs-button--blight ccs-button--no-border ccs-button--small">
          <img src="@/assets/icons/file_pdf.svg" alt="" class="button-icon">
          Скачать Pdf
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import Modal from '@/components/Modal.vue';
import Table from '@/components/Table.vue';

import Zone from '@/components/modals/inf_lists/Zone.vue'
import Equipment from '@/components/modals/inf_lists/Equipment.vue'

export default {
  name: 'InfList',
  components: {
    'ccs-table': Table,
    Modal,
    Zone,
    Equipment,
  },
  data() {
    return {
      editMode: false,
      modal: false,
      titles: {
        newZone: 'Новая зона',
        editZone: 'Редактирование зоны',
        newEquipment: 'Новая позиция',
        editEquipment: 'Редактирование позиции',
      },
      currentZoneID: 0,
      editableData: null,
      isZoneModal: false,
      columnsDefs: [{
        name: `name`,
        title: 'Наименование',
        prop: 'name',
      }, {
        name: `description`,
        title: `Тех. описание или ссылка на сайт с тех. описанием позиции`,
        prop: `description`,
      }, {
        name: `unit`,
        title: `Ед. изм.`,
        prop: `unit`,
        align: `center`,
      }, {
        name: `count`,
        title: `Кол-во на уч.`,
        prop: `count`,
        align: `center`,
      }, {
        name: `total_count`,
        title: `Всего`,
        prop: `total_count`,
        align: `center`,
      }, {
        name: `status`,
        title: `Наличие`,
        prop: `status`,
        align: `center`,
      }, {
        name: `sponsor`,
        title: `Поставщик\\Спонсор\\ответственный за обеспечение`,
        prop: `sponsor`,
        align: `center`,
      }, {
        name: `price`,
        title: `Примерная стоимость всего, руб`,
        prop: `price`,
        align: `right`,
      }, {
        name: `comment`,
        title: `Комментарий`,
        prop: `comment`,
      }, {
        name: `actions`,
        title: ``,
        prop: `id`,
        isActions: true,
      }],
    };
  },
  computed: {
    ...mapState('events', ['event']),
    ...mapState('skills', ['zones', 'skill']),
    ...mapGetters('session', [
      'rolesStatus',
      'permissionsStatus',
    ]),
    ...mapGetters('skills', [
      'equipmentsStatusID',
      'isEquipmentsOpened',
      'isEquipmentsBlockedByCE',
      'isEquipmentsBlockedBySpM',
      'isEquipmentsBlockedBySeM',
    ]),
    modalTitle() {
      if (this.isZoneModal) {
        return this.editableData ? this.titles.editZone : this.titles.newZone;
      } else {
        return this.editableData ? this.titles.editEquipment : this.titles.newEquipment;
      }
    },
    isEquipmentsBlocked() {
      return (this.rolesStatus.isAdmin && !this.isEquipmentsOpened)
        || (this.rolesStatus.isChiefExpert && !this.isEquipmentsOpened)
        || (this.rolesStatus.isSponsorManager && this.equipmentsStatusID >= 3)
        || (this.rolesStatus.isSectorManager && this.equipmentsStatusID >= 4)
    },
    isEquipmentsBlockAllowed() {
      return (this.rolesStatus.isAdmin && !this.isEquipmentsBlockedBySeM)
        || (this.rolesStatus.isChiefExpert && this.isEquipmentsOpened)
        || (this.rolesStatus.isSponsorManager && this.isEquipmentsBlockedByCE)
        || (this.rolesStatus.isSectorManager && this.isEquipmentsBlockedBySpM)
    },
    isEquipmentsUnblockAllowed() {
      return (this.rolesStatus.isAdmin && !this.isEquipmentsOpened)
        || (this.rolesStatus.isChiefExpert && this.isEquipmentsBlockedByCE)
        || (this.rolesStatus.isSponsorManager && this.isEquipmentsBlockedBySpM)
        || (this.rolesStatus.isSectorManager && this.isEquipmentsBlockedBySeM)
    },
    isEquipmentUpdateAllowed() {
      return (this.rolesStatus.isAdmin || !this.isEquipmentsBlocked)
        && (this.permissionsStatus.isZoneUpdateAllowed
          || this.permissionsStatus.isZoneStatusAllowed
          || this.ipermissionsStatus.sZoneSponsorAllowed
        );
    },
    isEquipmentDeleteAllowed() {
      return (this.rolesStatus.isAdmin || !this.isEquipmentsBlocked) && this.permissionsStatus.isZoneUpdateAllowed;
    },
  },
  methods: {
    ...mapActions('skills', [
      'publisZones',
      'deleteZone',
      'deleteEquipment',
      'blockEquipments',
      'unblockEquipments',
    ]),
    parseEquipmentStatus(equipment_status_slug) {
      if (equipment_status_slug === 'organizer') return 'Организатор';
      if (equipment_status_slug === 'union') return 'СОЮЗ';
      return 'Неизвестно';
    },
    switchEditMode() {
      this.editMode = !this.editMode;
    },
    switchModal() {
      this.modal = !this.modal;
      if (this.editableData) {
        this.editableData = null;
      }
    },
    startEquipmentAdding(zoneID) {
      this.isZoneModal = false;
      this.currentZoneID = zoneID;
      this.switchModal();
    },
    startEquipmentEditing(equipment) {
      this.startEquipmentAdding(equipment.zone_id)
      this.editableData = Object.assign({} ,equipment);
    },
    startZoneAdding() {
      this.isZoneModal = true;
      this.switchModal();
    },
    startZoneEditing(zone) {
      this.startZoneAdding()
      this.editableData = Object.assign({}, zone);
    },
    copyPublicLink() {
      const publicCode = this.skill.public_code;
      navigator.clipboard.writeText(
        `${process.env.VUE_APP_BASE_DOMAIN}/inf_list/${publicCode}`,
      ).then(() => {
        this.$toasted.success('Ссылка скопирована');
      }).catch(() => {
        this.$toasted.error('Произошла ошибка. Попробуйте ешё раз');
      });
    },
    async publish() {
      try {
        await this.publisZones();
        this.$toasted.success('Публичная ссылка сгенерирована');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async removeEquipment(equipment, zone_id) {
      try {
        equipment.zone_id = zone_id;
        await this.deleteEquipment(equipment);
        this.$toasted.success('Позиция удалена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async removeZone(zoneID) {
      try {
        await this.deleteZone(zoneID);
        this.$toasted.success('Зона удалена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async lockEquipments() {
      try {
        await this.blockEquipments();
        this.$toasted.success('ИЛ заблокирован');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async unlockEquipments() {
      try {
        await this.unblockEquipments();
        this.$toasted.success('ИЛ разблокирован');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.skill-inf-list {
  min-height: 100%;
  min-width: 100%;
  background: #fff;

  .edit-header {
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .title {
      margin-bottom: 15px;
      font-size: 20px;
      font-weight: bold;
      color: $primary;
    }

  }

  .indicators {
    justify-content: space-between;

    .indicator {
      min-height: 56px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      &-val {
        font-size: 30px;
        font-weight: bold;
        height: 24px;
        color: $surfaceDarker;
      }

      &-text {
        padding: 0 10px;
        font-size: 12px;
        line-height: 150%;
        color: $neutralLight;
      }

    }

  }

  .area-info {
    margin: 10px 0 10px -33px;
    padding: 0 33px;
    width: 100%;
    min-height: 43px;
    display: flex;
    justify-content: stretch;
    align-items: stretch;
    background: $neutralLighter;

    &__content {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
    }

    &__row {
      padding: 10px 15px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__title {
      font-size: 12px;
      color: $neutralLight;
    }

    &__text {
      font-size: 16px;
      color: $surfaceDarker;
    }

  }

  details {
    padding: 15px;
    margin: 15px;
    width: calc(100% - 60px);
    box-shadow: 0px 0px 10px rgba(129, 129, 129, 0.2);
    border-radius: 5px;
    background: $neutralLighter;
    transition: background ease-in-out .2s;

    &[open] {
      padding-bottom: 0;
      background: #fff;

      > summary {
        color: $primary;
        transition: color ease-in-out .2s;

        > .summary-icon {
          transform: rotate(180deg);
        }

      }

    }

    > summary {
      padding: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 20px;
      font-weight: bold;
      color: $surfaceDarker;

      &:hover {
        cursor: pointer;
      }

      &::-webkit-details-marker {
        display: none;
      }

      > .summary-icon {
        padding: 10px;
        margin-left: auto;
        height: 10px;
        width: 10px;
        justify-self: flex-end;
        transition: all ease-in-out .2s;
        border: 1px solid $primary;
        border-radius: 30px;
      }

      > .summary-icon:hover {
        cursor: pointer;
        background: $neutralLighter;
      }

    }

    .ccs-table, .break-line {
      margin-left: -15px;
      width: calc(100% + 30px);
    }

    .break-line {
      height: 20px;
      border-top: 1px solid #D8DDEF;
    }

    .ccs-table__actions {
      margin: 0 0 0 -15px;
      width: calc(100% + 30px);
      background: $neutralLighter;
      border-top: 1px solid #D8DDEF;
    }

    > .ccs-button {
      margin-bottom: 20px;
    }

  }

}
</style>
